<template>
  <div>
    <GlobalLoadingSpinner />
    <NuxtLayout v-if="!isUpNavFlagLoading" :name="layout">
      <NuxtPage></NuxtPage>
    </NuxtLayout>
  </div>
</template>
<script setup lang="ts">
import { useUpNavigationStore } from "~/store/upNavigationStore.ts";
import { useLayout } from "~/composables/useLayout.ts";
import GlobalLoadingSpinner from "~/components/shared/GlobalLoadingSpinner.vue";

const { layout } = useLayout();
const { isUpNavFlagLoading } = storeToRefs(useUpNavigationStore());
</script>
